/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsFromJSON, FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsToJSON, } from './FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults';
/**
 * Check if a given object implements the FxIdWebFeaturesStoreYandexGamesPurchaseResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreYandexGamesPurchaseResponse(value) {
    if (!('TokenSuccesses' in value) || value['TokenSuccesses'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreYandexGamesPurchaseResponseFromJSON(json) {
    return FxIdWebFeaturesStoreYandexGamesPurchaseResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreYandexGamesPurchaseResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'TokenSuccesses': (json['TokenSuccesses'].map(FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsFromJSON)),
    };
}
export function FxIdWebFeaturesStoreYandexGamesPurchaseResponseToJSON(json) {
    return FxIdWebFeaturesStoreYandexGamesPurchaseResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreYandexGamesPurchaseResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'TokenSuccesses': (value['TokenSuccesses'].map(FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreYandexGamesPurchaseResponse.js.map